<script lang="ts">
import { defineComponent } from 'vue';
import { useFixturesStore } from '@/stores/fixtures';
import { mapActions } from 'pinia';
import { formatDate } from '@/utils/format';
import Markets from '@/components/event/markets.vue';
import Fixture from '@/components/event/fixture.vue';
import Description from '@/components/event/description.vue';
import MatchState from '@/components/event/match-state.vue';
import Headline from '@/components/headline.vue';

export default defineComponent({
  name: 'detailed-fixture',
  components: { Headline, MatchState, Fixture, Markets, Description },
  computed: {
    id() {
      return parseInt(this.$route.params.id as string);
    },
    markets() {
      const oc = ['Open', 'Suspended', 'Closed'];
      return (
        this.fixture?.Markets?.sort((a: any, b: any) => {
          const tsa = oc.indexOf(a.TradingStatus);
          const tsb = oc.indexOf(b.TradingStatus);
          if (tsa > tsb) return 1;
          if (tsa < tsb) return -1;
          if (a.MarketType.Name > b.MarketType.Name) return 1;
          if (a.MarketType.Name < b.MarketType.Name) return -1;
          return a.Name > b.Name ? 1 : -1;
        }) || []
      );
    },
  },
  data() {
    return {
      loading: false,
      textId: null,
      fixture: null as null | object,
      section: 'markets',
      sections: [
        { name: 'Маркеты', id: 'markets' },
        { name: 'Инфо', id: 'info' },
      ],
    };
  },
  methods: {
    ...mapActions(useFixturesStore, ['fetchFixtureDirect']),
    formatDate,
    async loadFixture() {
      this.loading = true;
      return this.fetchFixtureDirect(this.id)
        .then((fixture) => {
          this.fixture = fixture;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onKeyUp() {
      const id = parseInt(this.textId || '');
      this.$router.push({ name: 'detailed-event', params: { id } });
    },
  },
  mounted() {
    if (this.id) {
      this.loadFixture();
    }
  },
  watch: {
    '$route.params.id'(val) {
      if (val) {
        this.loadFixture();
      } else {
        this.fixture = null;
      }
    },
  },
});
</script>

<template>
  <template v-if="loading">
    <div class="relative z-10">
      <div
        style="height: 100vh; position: absolute; left: 0; right: 0"
        class="place-content-center text-center w-full bg-opacity-20 bg-black"
      >
        <i class="pi pi-spinner animate-spin text-gray-200" style="font-size: 5em" />
      </div>
    </div>
  </template>
  <template v-if="!fixture && !loading">
    <div class="text-center p-2">
      Если не дунуть - чуда не произойдёт<br />
      <InputText
        v-model="textId"
        class="m-2 p-2 text-center"
        placeholder="ID события"
        @keyup.enter="onKeyUp"
      />
    </div>
  </template>
  <template v-if="fixture">
    <teleport to="#title">
      <headline class="mx-4 my-2">Детали события</headline>
    </teleport>
    <div style="max-height: 100vh; overflow: scroll">
      <div class="sticky top-0 bg-gray-300 dark:bg-gray-700 p-2 z-10">
        <fixture
          :fixture="fixture"
          v-model:section="section"
          :sections="sections"
          :refresh="loadFixture"
        />
      </div>

      <match-state :fixture="fixture" v-if="fixture.Updates?.length" />

      <markets v-if="section === 'markets'" :markets="markets" @reload="loadFixture"/>

      <template v-else-if="section === 'info'">
        <description :fixture="fixture" />
      </template>
    </div>
  </template>
</template>

<style scoped lang="scss"></style>
